import BaseModelFactory from './base.factory'
import UserCorpEmailService from './../services/UserCorpEmail.service'
import UserCorpEmail from './../models/user-corp-email.model'

class UserCorpEmailFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserCorpEmailService, Model: UserCorpEmail }
    )
  static findById = async id => await this._findBy({ id: id }, { Service: UserCorpEmailService, Model: UserCorpEmail })
  static findByUserId = async userId =>
    await this._findBy({ user_id: userId }, { Service: UserCorpEmailService, Model: UserCorpEmail })
  static create = payload =>
    this._create(payload, {
      Service: UserCorpEmailService,
      Model: UserCorpEmail,
    })
}

export default UserCorpEmailFactory
